{
    "v": "5.12.1",
    "fr": 60,
    "ip": 0,
    "op": 3000,
    "w": 1080,
    "h": 1920,
    "nm": "2025-08-18_Kiosk-SelfCheckout_All",
    "ddd": 0,
    "assets": [],
    "layers": [
        {
            "ddd": 0,
            "ind": 1,
            "ty": 4,
            "nm": "Logo",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [540, 641.371, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [58, 58, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "d": 1,
                                    "ty": "el",
                                    "s": {
                                        "a": 0,
                                        "k": [69.732, 81.292],
                                        "ix": 2
                                    },
                                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                                    "nm": "Ellipse Path 1",
                                    "mn": "ADBE Vector Shape - Ellipse",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [52.137, 26.916],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Kkiosk",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 1,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "gr",
                            "it": [
                                {
                                    "d": 3,
                                    "ty": "el",
                                    "s": {
                                        "a": 0,
                                        "k": [162.774, 144.168],
                                        "ix": 2
                                    },
                                    "p": { "a": 0, "k": [0, 0], "ix": 3 },
                                    "nm": "Ellipse Path 1",
                                    "mn": "ADBE Vector Shape - Ellipse",
                                    "hd": false
                                },
                                {
                                    "ty": "tr",
                                    "p": {
                                        "a": 0,
                                        "k": [52.068, 26.902],
                                        "ix": 2
                                    },
                                    "a": { "a": 0, "k": [0, 0], "ix": 1 },
                                    "s": { "a": 0, "k": [100, 100], "ix": 3 },
                                    "r": { "a": 0, "k": 0, "ix": 6 },
                                    "o": { "a": 0, "k": 100, "ix": 7 },
                                    "sk": { "a": 0, "k": 0, "ix": 4 },
                                    "sa": { "a": 0, "k": 0, "ix": 5 },
                                    "nm": "Transform"
                                }
                            ],
                            "nm": "Kkiosk",
                            "np": 1,
                            "cix": 2,
                            "bm": 0,
                            "ix": 2,
                            "mn": "ADBE Vector Group",
                            "hd": false
                        },
                        {
                            "ty": "mm",
                            "mm": 5,
                            "nm": "Merge Paths 1",
                            "mn": "ADBE Vector Filter - Merge",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Kkiosk",
                    "np": 4,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 8.717],
                                        [0, 0],
                                        [0, 0],
                                        [-4.767, 0.117],
                                        [0, -6.995],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [-8.033, 0],
                                        [0, 0],
                                        [0, 0],
                                        [3.538, -3.197],
                                        [5.629, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [22.994, 70.704],
                                        [-9.961, 70.704],
                                        [-22.994, 56.85],
                                        [-22.994, -47.368],
                                        [0.094, -65.567],
                                        [12.965, -70.704],
                                        [22.994, -59.774],
                                        [22.994, 70.567]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [-66.222, 25.331], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Kkiosk",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 2,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [3.718, 1.746],
                                        [2.592, 3.187],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 8.58],
                                        [0, 0],
                                        [0, 0],
                                        [-4.852, 0.128],
                                        [0, -7.323],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, -3.771],
                                        [0.695, -1.301],
                                        [1.191, -0.871],
                                        [0, 0],
                                        [0, -2.596],
                                        [-3.609, -4.153]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [-4.108, 0.042],
                                        [-3.721, -1.746],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-8.445, 0],
                                        [0, 0],
                                        [0, 0],
                                        [3.753, -3.077],
                                        [5.82, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [7.022, 0],
                                        [-0.065, 1.473],
                                        [-0.695, 1.301],
                                        [0, 0],
                                        [-3.609, 3.771],
                                        [0, 2.596],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [79.243, 93.055],
                                        [34.431, 93.055],
                                        [22.541, 90.466],
                                        [12.952, 82.972],
                                        [-31.67, 29.551],
                                        [-31.67, 93.055],
                                        [-65.579, 93.055],
                                        [-79.243, 79.01],
                                        [-79.243, -70.513],
                                        [-55.142, -88.111],
                                        [-41.862, -93.057],
                                        [-31.424, -81.99],
                                        [-31.424, 10.369],
                                        [32.081, -45.784],
                                        [64.434, -45.784],
                                        [74.271, -39.854],
                                        [73.118, -35.64],
                                        [70.254, -32.34],
                                        [23.228, 10.97],
                                        [18.417, 19.687],
                                        [23.228, 28.568]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [375.966, 2.98], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Kkiosk",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 3,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [3.683, 1.742],
                                        [2.598, 3.137],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 8.58],
                                        [0, 0],
                                        [0, 0],
                                        [-4.905, 0.117],
                                        [0, -7.323],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, -3.771],
                                        [0.66, -1.296],
                                        [1.134, -0.909],
                                        [0, 0],
                                        [0, -2.596],
                                        [-3.634, -3.935],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [-4.072, -0.019],
                                        [-3.683, -1.742],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-8.198, 0],
                                        [0, 0],
                                        [0, 0],
                                        [3.811, -3.09],
                                        [5.848, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [7.242, 0],
                                        [-0.068, 1.452],
                                        [-0.66, 1.296],
                                        [0, 0],
                                        [-3.415, 3.771],
                                        [0, 2.596],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [79.435, 93.056],
                                        [34.429, 93.056],
                                        [22.653, 90.382],
                                        [13.116, 82.973],
                                        [-31.697, 29.552],
                                        [-31.697, 93.056],
                                        [-65.854, 93.056],
                                        [-79.516, 79.011],
                                        [-79.516, -70.512],
                                        [-55.388, -88.11],
                                        [-41.944, -93.056],
                                        [-31.697, -81.989],
                                        [-31.697, 10.37],
                                        [31.888, -45.783],
                                        [64.241, -45.783],
                                        [74.106, -39.854],
                                        [73.002, -35.685],
                                        [70.281, -32.339],
                                        [23.062, 10.971],
                                        [18.445, 19.688],
                                        [23.062, 28.568],
                                        [79.516, 93.056]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [-175.099, 2.979], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Kkiosk",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 4,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [3.634, 1.732],
                                        [2.518, 3.142],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 8.635],
                                        [0, 0],
                                        [0, 0],
                                        [-4.786, 0.085],
                                        [0, -7.214],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, -3.716],
                                        [0.65, -1.286],
                                        [1.121, -0.905],
                                        [0, 0],
                                        [0, -2.569],
                                        [-3.552, -3.935],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [-4.026, 0.023],
                                        [-3.634, -1.732],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [-8.198, 0],
                                        [0, 0],
                                        [0, 0],
                                        [3.664, -3.08],
                                        [5.738, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [6.94, 0],
                                        [-0.064, 1.44],
                                        [-0.65, 1.286],
                                        [0, 0],
                                        [-3.361, 3.716],
                                        [0, 2.569],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [78.15, 92.318],
                                        [33.801, 92.318],
                                        [22.163, 89.722],
                                        [12.816, 82.317],
                                        [-31.123, 29.333],
                                        [-31.123, 92.318],
                                        [-64.979, 92.318],
                                        [-78.232, 78.382],
                                        [-78.232, -69.966],
                                        [-54.486, -87.427],
                                        [-41.425, -92.318],
                                        [-31.123, -81.388],
                                        [-31.123, 10.233],
                                        [31.233, -45.483],
                                        [63.312, -45.483],
                                        [72.822, -39.608],
                                        [71.738, -35.472],
                                        [69.051, -32.148],
                                        [22.598, 10.834],
                                        [18.062, 19.469],
                                        [22.598, 28.295],
                                        [78.232, 92.263]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.921568632126, 0.105882354081,
                                    0.184313729405, 1
                                ],
                                "ix": 4
                            },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [-376.978, 2.979], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Kkiosk",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 5,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [42.19, 0],
                                        [5.411, 5.656],
                                        [0, 0],
                                        [-1.311, 0.714],
                                        [-1.486, 0.135],
                                        [-8.551, -3.17],
                                        [-10.704, -0.195],
                                        [0, 7.733],
                                        [14.673, 3.061],
                                        [0, 0],
                                        [0, 23.527],
                                        [-37.161, 0],
                                        [-15.038, -4.951],
                                        [0, -4.563],
                                        [0.692, -1.262],
                                        [1.15, -0.867],
                                        [0, 0],
                                        [15.368, 0.098],
                                        [0, -6.531],
                                        [-12.078, -2.487],
                                        [0, 0],
                                        [0, -22.543]
                                    ],
                                    "o": [
                                        [0, 31.451],
                                        [-45.224, 0],
                                        [0, 0],
                                        [0.919, -1.176],
                                        [1.311, -0.714],
                                        [5.632, 0],
                                        [10.039, 3.729],
                                        [14.867, 0],
                                        [0, -4.727],
                                        [0, 0],
                                        [-29.537, -6.121],
                                        [0, -29.866],
                                        [15.834, -0.12],
                                        [15.085, 5.164],
                                        [-0.112, 1.435],
                                        [-0.692, 1.263],
                                        [0, 0],
                                        [-13.517, -7.312],
                                        [-16.066, 0],
                                        [0, 5.929],
                                        [0, 0],
                                        [31.151, 6.121],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [73.546, 23.556],
                                        [-0.805, 72.195],
                                        [-73.546, 50.335],
                                        [-56.657, 33.53],
                                        [-53.277, 30.664],
                                        [-49.036, 29.377],
                                        [-32.64, 35.497],
                                        [-1.299, 41.427],
                                        [23.841, 29.759],
                                        [6.955, 18.501],
                                        [-19.169, 13.036],
                                        [-67.397, -26.312],
                                        [0.915, -72.191],
                                        [47.531, -64.895],
                                        [66.222, -51.233],
                                        [65.001, -47.14],
                                        [62.207, -43.909],
                                        [48.134, -30.465],
                                        [4.139, -41.751],
                                        [-18.785, -31.258],
                                        [-0.478, -20.574],
                                        [25.837, -15.437],
                                        [73.465, 23.338]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [210.581, 26.709], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Kkiosk",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 6,
                    "mn": "ADBE Vector Group",
                    "hd": false
                },
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 12.269],
                                        [-4.402, 4.114],
                                        [-6.027, 0],
                                        [-4.402, -4.114],
                                        [-0.409, -6.012],
                                        [13.059, 0]
                                    ],
                                    "o": [
                                        [0.409, -6.012],
                                        [4.402, -4.114],
                                        [6.024, 0],
                                        [4.402, 4.114],
                                        [0, 12.269],
                                        [-13.062, 0]
                                    ],
                                    "v": [
                                        [-23.719, 0.014],
                                        [-16.231, -15.745],
                                        [0.001, -22.148],
                                        [16.231, -15.745],
                                        [23.719, 0.014],
                                        [0.001, 22.148]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [-62.711, -76.838], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Kkiosk",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 7,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 4500,
            "st": 0,
            "ct": 1,
            "cp": true,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 2,
            "ty": 4,
            "nm": "Ellipse 1",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 0,
                            "s": [169.776]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 394,
                            "s": [195.776]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 988,
                            "s": [222.776]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 1468,
                            "s": [172.776]
                        },
                        { "t": 3000, "s": [169.776] }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 0,
                            "s": [841.037, 1770.936, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 315,
                            "s": [765.037, 1786.936, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 1622,
                            "s": [699.037, 2512.936, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        { "t": 3000, "s": [841.037, 1770.936, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [55, 55, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "d": 1,
                            "ty": "el",
                            "s": { "a": 0, "k": [4505.021, 2954.223], "ix": 2 },
                            "p": { "a": 0, "k": [0, 0], "ix": 3 },
                            "nm": "Ellipse Path 1",
                            "mn": "ADBE Vector Shape - Ellipse",
                            "hd": false
                        },
                        {
                            "ty": "gs",
                            "o": { "a": 0, "k": 100, "ix": 9 },
                            "w": { "a": 0, "k": 5, "ix": 10 },
                            "g": {
                                "p": 3,
                                "k": {
                                    "a": 0,
                                    "k": [
                                        0, 1, 1, 1, 0.77, 1, 1, 1, 1, 1, 1, 1,
                                        0, 0.15, 0.77, 0.075, 1, 0
                                    ],
                                    "ix": 8
                                }
                            },
                            "s": {
                                "a": 0,
                                "k": [1518.429, -1264.071],
                                "ix": 4
                            },
                            "e": {
                                "a": 0,
                                "k": [-1517.625, 1263.351],
                                "ix": 5
                            },
                            "t": 1,
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "ml2": { "a": 0, "k": 10, "ix": 13 },
                            "bm": 0,
                            "nm": "Gradient Stroke 1",
                            "mn": "ADBE Vector Graphic - G-Stroke",
                            "hd": false
                        },
                        {
                            "ty": "gf",
                            "o": { "a": 0, "k": 100, "ix": 10 },
                            "r": 1,
                            "bm": 0,
                            "g": {
                                "p": 3,
                                "k": {
                                    "a": 0,
                                    "k": [
                                        0, 1, 1, 1, 0.77, 1, 1, 1, 1, 1, 1, 1,
                                        0, 0.15, 0.77, 0.075, 1, 0
                                    ],
                                    "ix": 9
                                }
                            },
                            "s": { "a": 0, "k": [-579.151, 1491.402], "ix": 5 },
                            "e": { "a": 0, "k": [579.653, -1492.519], "ix": 6 },
                            "t": 1,
                            "nm": "Gradient Fill 1",
                            "mn": "ADBE Vector Graphic - G-Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 4500,
            "st": 0,
            "ct": 1,
            "cp": true,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 3,
            "ty": 4,
            "nm": "Ellipse",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 0,
                            "s": [258.498]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 339,
                            "s": [282.498]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 1852,
                            "s": [265.498]
                        },
                        {
                            "i": { "x": [0.833], "y": [0.833] },
                            "o": { "x": [0.167], "y": [0.167] },
                            "t": 2469,
                            "s": [312.498]
                        },
                        { "t": 2990, "s": [258.498] }
                    ],
                    "ix": 10
                },
                "p": {
                    "a": 1,
                    "k": [
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 0,
                            "s": [611.253, 1771.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 240,
                            "s": [557.253, 1755.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 1156,
                            "s": [477.253, 2847.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 1917,
                            "s": [709.253, 1779.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        {
                            "i": { "x": 0.833, "y": 0.833 },
                            "o": { "x": 0.167, "y": 0.167 },
                            "t": 2414,
                            "s": [637.253, 2527.165, 0],
                            "to": [0, 0, 0],
                            "ti": [0, 0, 0]
                        },
                        { "t": 2990, "s": [611.253, 1771.165, 0] }
                    ],
                    "ix": 2,
                    "l": 2
                },
                "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [70, 70, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "d": 1,
                            "ty": "el",
                            "s": { "a": 0, "k": [2666.901, 4967.943], "ix": 2 },
                            "p": { "a": 0, "k": [0, 0], "ix": 3 },
                            "nm": "Ellipse Path 1",
                            "mn": "ADBE Vector Shape - Ellipse",
                            "hd": false
                        },
                        {
                            "ty": "gs",
                            "o": { "a": 0, "k": 100, "ix": 9 },
                            "w": { "a": 0, "k": 5, "ix": 10 },
                            "g": {
                                "p": 3,
                                "k": {
                                    "a": 0,
                                    "k": [
                                        0, 1, 1, 1, 0.77, 1, 1, 1, 1, 1, 1, 1,
                                        0, 0.15, 0.77, 0.075, 1, 0
                                    ],
                                    "ix": 8
                                }
                            },
                            "s": { "a": 0, "k": [1355.881, 202.972], "ix": 4 },
                            "e": { "a": 0, "k": [-1357.609, -202.64], "ix": 5 },
                            "t": 1,
                            "lc": 1,
                            "lj": 1,
                            "ml": 10,
                            "ml2": { "a": 0, "k": 10, "ix": 13 },
                            "bm": 0,
                            "nm": "Gradient Stroke 1",
                            "mn": "ADBE Vector Graphic - G-Stroke",
                            "hd": false
                        },
                        {
                            "ty": "gf",
                            "o": { "a": 0, "k": 100, "ix": 10 },
                            "r": 1,
                            "bm": 0,
                            "g": {
                                "p": 3,
                                "k": {
                                    "a": 0,
                                    "k": [
                                        0, 1, 1, 1, 0.77, 1, 1, 1, 1, 1, 1, 1,
                                        0, 0.15, 0.77, 0.075, 1, 0
                                    ],
                                    "ix": 9
                                }
                            },
                            "s": { "a": 0, "k": [864.744, 2197.741], "ix": 5 },
                            "e": {
                                "a": 0,
                                "k": [-867.024, -2198.973],
                                "ix": 6
                            },
                            "t": 1,
                            "nm": "Gradient Fill 1",
                            "mn": "ADBE Vector Graphic - G-Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [0, 0], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 3,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 4500,
            "st": 0,
            "ct": 1,
            "cp": true,
            "bm": 0
        },
        {
            "ddd": 0,
            "ind": 4,
            "ty": 4,
            "nm": "Blue BG",
            "sr": 1,
            "ks": {
                "o": { "a": 0, "k": 100, "ix": 11 },
                "r": { "a": 0, "k": 0, "ix": 10 },
                "p": { "a": 0, "k": [540, 960, 0], "ix": 2, "l": 2 },
                "a": { "a": 0, "k": [559.75, 1218.25, 0], "ix": 1, "l": 2 },
                "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
            },
            "ao": 0,
            "shapes": [
                {
                    "ty": "gr",
                    "it": [
                        {
                            "ind": 0,
                            "ty": "sh",
                            "ix": 1,
                            "ks": {
                                "a": 0,
                                "k": {
                                    "i": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "o": [
                                        [0, 0],
                                        [0, 0],
                                        [0, 0],
                                        [0, 0]
                                    ],
                                    "v": [
                                        [-559.5, 1218],
                                        [559.5, 1218],
                                        [559.5, -1218],
                                        [-559.5, -1218]
                                    ],
                                    "c": true
                                },
                                "ix": 2
                            },
                            "nm": "Path 1",
                            "mn": "ADBE Vector Shape - Group",
                            "hd": false
                        },
                        {
                            "ty": "fl",
                            "c": {
                                "a": 0,
                                "k": [
                                    0.125490196078, 0.760784313725,
                                    0.952941176471, 1
                                ],
                                "ix": 4
                            },
                            "o": { "a": 0, "k": 100, "ix": 5 },
                            "r": 1,
                            "bm": 0,
                            "nm": "Fill 1",
                            "mn": "ADBE Vector Graphic - Fill",
                            "hd": false
                        },
                        {
                            "ty": "tr",
                            "p": { "a": 0, "k": [559.75, 1218.25], "ix": 2 },
                            "a": { "a": 0, "k": [0, 0], "ix": 1 },
                            "s": { "a": 0, "k": [100, 100], "ix": 3 },
                            "r": { "a": 0, "k": 0, "ix": 6 },
                            "o": { "a": 0, "k": 100, "ix": 7 },
                            "sk": { "a": 0, "k": 0, "ix": 4 },
                            "sa": { "a": 0, "k": 0, "ix": 5 },
                            "nm": "Transform"
                        }
                    ],
                    "nm": "Group 1",
                    "np": 2,
                    "cix": 2,
                    "bm": 0,
                    "ix": 1,
                    "mn": "ADBE Vector Group",
                    "hd": false
                }
            ],
            "ip": 0,
            "op": 3088,
            "st": 0,
            "ct": 1,
            "cp": true,
            "bm": 0
        }
    ],
    "markers": [],
    "props": {}
}
